exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/meghneel/work/shree_translogic_dashboard/src/app/l-r-acknowledge/l-r-acknowledge.component.css
// module id = ../../../../../src/app/l-r-acknowledge/l-r-acknowledge.component.css
// module chunks = main